<div *ngIf="price" class="nightly-pricing-outer">
  <div id="w-node-bda1848e-26e1-cac8-1be7-e7934df41f5d-afacc4eb">
    <div class="riftsoft-trinidad">Listed Price</div>
    <div class="icon-w-label">
      <div class="element-outer">
        <div class="element-inner currency-rounded-left"><div class="element-bold">$</div></div>
        <input
          id="price-total"
          type="number"
          class="text-field-rounded-right w-input"
          min="{{ minimumFee + feedbackIncentive }}"
          [formControl]="totalPrice"
          [containerElement]="priceError"
        />
      </div>
      <div class="rift-soft-title">/ Night</div>
    </div>
  </div>
  <div id="w-node-_85d3e16d-f1d9-83ee-a163-c26a67b265f4-afacc4eb">
    <div class="riftsoft-trinidad">Deductions</div>
    <div class="difference-wrapper">
      <div class="difference-icon">
        <div class="w-embed">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 28 28"
            style="enable-background: new 0 0 28 28"
            xml:space="preserve"
          >
            <style type="text/css">
              .icon-pricesubtraction {
                fill: #e3530d;
              }
            </style>
            <path
              class="icon-pricesubtraction"
              d="M24.7,12.7h-12H5.3h-2C2.6,12.7,2,13.3,2,14c0,0.7,0.6,1.3,1.3,1.3h2h7.3h12c0.7,0,1.3-0.6,1.3-1.3
      C26,13.3,25.4,12.7,24.7,12.7z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="rift-soft-title">${{ feedbackIncentive }} CurbNTurf Cash</div>
    </div>
    <div class="difference-wrapper">
      <div class="difference-icon">
        <div class="w-embed">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 28 28"
            style="enable-background: new 0 0 28 28"
            xml:space="preserve"
          >
            <style type="text/css">
              .icon-pricesubtraction {
                fill: #e3530d;
              }
            </style>
            <path
              class="icon-pricesubtraction"
              d="M24.7,12.7h-12H5.3h-2C2.6,12.7,2,13.3,2,14c0,0.7,0.6,1.3,1.3,1.3h2h7.3h12c0.7,0,1.3-0.6,1.3-1.3
      C26,13.3,25.4,12.7,24.7,12.7z"
            ></path>
          </svg>
        </div>
      </div>
      <div *ngIf="price?.value + feedbackIncentive + minimumFee >= totalPrice?.value" class="rift-soft-title">
        ${{ minimumFee }} for CurbNTurf
      </div>
      <div *ngIf="price?.value + feedbackIncentive + minimumFee < totalPrice?.value" class="rift-soft-title">
        {{ feePercentage * 100 | number : '1.0-1' }}% for CurbNTurf
      </div>
    </div>
  </div>
  <div id="w-node-_27a10c60-7f6a-bfaa-f349-9d1a3b6ccdde-afacc4eb">
    <div class="riftsoft-trinidad">your take home pay</div>
    <div class="icon-w-label">
      <div class="equals-wrapper">
        <div class="w-embed">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 28 28"
            style="enable-background: new 0 0 28 28"
            xml:space="preserve"
          >
            <style type="text/css">
              .icon-priceequals {
                fill: #e3530d;
              }
            </style>
            <g>
              <path
                class="icon-priceequals"
                d="M24.7,17.1h-12H5.3h-2c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h2h7.3h12c0.7,0,1.3-0.6,1.3-1.3
        C26,17.7,25.4,17.1,24.7,17.1z"
              ></path>
              <path
                class="icon-priceequals"
                d="M24.7,8.2h-12H5.3h-2C2.6,8.2,2,8.8,2,9.5s0.6,1.3,1.3,1.3h2h7.3h12c0.7,0,1.3-0.6,1.3-1.3
        C26,8.8,25.4,8.2,24.7,8.2z"
              ></path>
            </g>
          </svg>
        </div>
      </div>
      <div class="element-outer">
        <div class="element-inner currency-rounded-left"><div class="element-bold">$</div></div>
        <input
          id="price"
          type="number"
          class="text-field-rounded-right w-input"
          min="0"
          [formControl]="price"
          [containerElement]="priceError"
        />
      </div>
      <div class="rift-soft-title nowrap">/ night</div>
    </div>
  </div>
</div>

<p *ngIf="price?.value + minimumFee + feedbackIncentive >= totalPrice?.value" class="fine-print">
  CurbNTurf charges ${{ minimumFee }} minimum fee to the guest to cover the overhead and other cost associated to
  providing the best service and platform possible for our customers.
</p>
<p *ngIf="price?.value + minimumFee + feedbackIncentive < totalPrice?.value" class="fine-print">
  CurbNTurf charges {{ feePercentage * 100 | number : '1.0-1' }}% to the guest to cover the overhead and other cost
  associated to providing the best service and platform possible for our customers.
</p>

<div class="price-error">
  <div #priceError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
</div>
